'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _underscore = require('underscore');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _pubNubHelpers = require('conversations-core/utils/pubNubHelpers');

var _ClientActions = require('conversations-core/actions/ClientActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIME_CALLS_TO_AVERAGE = 3;

var timeResolver = function timeResolver(client) {
  return _q2.default.Promise(function (resolve, reject) {
    return client.time(function (status, response) {
      if (status.error) {
        reject(status);
      }

      resolve(response);
    });
  });
};

var getTimetoken = (0, _getIn2.default)(['value', 'timetoken']);

exports.default = _defineProperty({}, _ActionTypes2.default.GET_SERVER_TIME_OFFSET, function (action, getState, dispatch, client) {
  var now = Date.now();
  var timePromises = (0, _underscore.times)(TIME_CALLS_TO_AVERAGE, (0, _underscore.partial)(timeResolver, client));

  _q2.default.allSettled(timePromises).then(function (settledPromises) {
    var successfulRequests = settledPromises.filter(function (settled) {
      return settled.state === 'fulfilled';
    });

    if (successfulRequests.length === 0) {
      dispatch((0, _ClientActions.getServerTimeOffsetFailed)());
      return;
    }

    var totalOfSuccessfulRequests = successfulRequests.reduce(function (total, request) {
      var timetoken = getTimetoken(request);
      var timestamp = (0, _pubNubHelpers.getTimestampFromToken)(timetoken);
      var difference = timestamp - now;

      return total + difference;
    }, 0);

    var offsetInMs = Math.floor(totalOfSuccessfulRequests / successfulRequests.length);

    dispatch((0, _ClientActions.getServerTimeOffsetSucceeded)({ offsetInMs: offsetInMs }));
  });
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/timeHandlers.js
// module id = 504
// module chunks = 0